import { useAppSelector } from "../app/store";

const useTicket = (ticket: any) => {
  const user = useAppSelector((state) => state.auth.user);
  const { id: userId, role: userRole, department_id: userDept } = user || {};
  const {
    id: ticketId,
    raised_by,
    raised_by_dept_id: ticketDept,
    workflow_status: status,
  } = ticket || {};

  //
  const fromSameDept = userDept === ticketDept;
  const isCreator = userId === raised_by;

  const isEndedTicket = status === "canceled" || status === "closed";
  const canReopenTicket = (isCreator || fromSameDept) && isEndedTicket;
  const canPerformAction = (isCreator || fromSameDept) && !isEndedTicket;
  
  return {
    ticketId,
    userId,
    userRole,
    fromSameDept,
    isCreator,
    canReopenTicket,
    canPerformAction
  };
};

export default useTicket;
